import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Lines } from "../components/Reveal";
import { useSiteImages } from "../lib/siteContent";

export default function Editorial() {
    const ref = useRef(null);
    const overrides = useSiteImages();
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

    return (
        <section ref={ref} data-testid="editorial-campaign" className="relative h-[90svh] overflow-hidden">
            <motion.div style={{ y }} className="absolute inset-[-10%]">
                <img
                    src={overrides.editorial || "/assets/EDITORIAL_CAMPAIGN.jpg"}
                    alt="Vantage Owners Club editorial campaign"
                    loading="lazy"
                    className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-black/35" />
            </motion.div>
            <div className="relative z-10 flex h-full flex-col items-center justify-center text-center">
                <h2 className="font-display text-[14vw] font-black uppercase leading-[0.85] tracking-tighter text-[#F2F0EA] sm:text-[9vw]">
                    <Lines lines={["Own", "Your", "Perspective"]} />
                </h2>
                <p className="mt-8 text-[9px] uppercase tracking-[0.5em] text-[rgba(242,240,234,0.6)]">
                    Vantage Owners Club — Established 2026
                </p>
            </div>
        </section>
    );
}
